const JWT_TOKEN_REG = new RegExp("^([\\w-]+(\\.)){2}[\\w-]+$");

const JWT_TOKEN_KEY = "JWT_TOKEN";

export class JwtUtil {
  static getJwtToken() {
    const token = localStorage.getItem(JWT_TOKEN_KEY);
    if (token && JWT_TOKEN_REG.test(token)) {
      return token;
    }
    return "";
  }

  static setJwtToken(token) {
    if (JWT_TOKEN_REG.test(token)) {
      localStorage.setItem(JWT_TOKEN_KEY, token);
    }
  }

  static clearJwtToken() {
    localStorage.removeItem(JWT_TOKEN_KEY);
  }
}
